export function getZipCodeForServiceableZipCode(isNewCustomer, isNewLocationForExistingCustomer, isEditLocation, newZip, existingZip, editedZip) {
    return isNewCustomer || isNewLocationForExistingCustomer ? newZip : isEditLocation ? editedZip : existingZip
}

export function getCountryForServiceableZipCode(isNewCustomer, isNewLocationForExistingCustomer, isEditLocation, newCountry, existingCountry, editedCountry) {
    return isNewCustomer || isNewLocationForExistingCustomer ? newCountry : isEditLocation ? editedCountry : existingCountry;
}